import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-fields",
    },
  }

  remove(e) {
    e.preventDefault()

    const wrapper = e.target.closest(this.wrapperSelectorValue)

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"

      const input = wrapper.querySelector("input[name*='_destroy']")
      input.value = "1"
    }
  }
}

